/**
 * Holds the singleton promise that resolves once the Mixpanel IndexedDB has
 * been sanitized.  Stored here rather than in index.tsx so any module —
 * including MixpanelProvider — can import it without creating a circular
 * dependency back to the app entry point.
 *
 * index.tsx calls `setMixpanelIdbReady` at module load time (before React
 * renders) so the promise is always populated by the time analytics providers
 * initialize.
 */

let _mixpanelIdbReady: Promise<void> = Promise.resolve();

export function setMixpanelIdbReady(p: Promise<void>): void {
  _mixpanelIdbReady = p;
}

export function getMixpanelIdbReady(): Promise<void> {
  return _mixpanelIdbReady;
}
